export enum DocumentStatus {
  Upload = 'Upload',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
}
